module.exports = __webpack_public_path__ + "static/images/containers/Schedule/images/calendar_item_selected_shadow.3e7cb7c0.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Schedule/images/calendar_item_selected_shadow.png
// module id = 3249
// module chunks = 11